import React, { useState } from 'react';
import { Send, BrainCircuit } from 'lucide-react';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';

const AIInsightsSection = () => {
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      content: 'Hello! I\'m your AI trading assistant. Ask me about market trends, portfolio optimization, or risk management strategies.',
    },
  ]);
  const [input, setInput] = useState('');

  const handleSend = (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = { role: 'user', content: input };
    setMessages((prev) => [...prev, userMessage]);

    // Simulate AI response
    setTimeout(() => {
      const responses = [
        'Based on current market conditions, your portfolio shows strong diversification across major assets.',
        'Your win rate of 80% is exceptional. Consider maintaining your current strategy while gradually scaling position sizes.',
        'The current market volatility suggests focusing on assets with lower correlation to reduce overall portfolio risk.',
        'Your risk/reward ratio of 2.8 is excellent. This indicates disciplined trade management and proper stop-loss placement.',
      ];
      const aiMessage = {
        role: 'assistant',
        content: responses[Math.floor(Math.random() * responses.length)],
      };
      setMessages((prev) => [...prev, aiMessage]);
    }, 1000);

    setInput('');
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-4xl font-bold text-slate-900 mb-2">AI Insights</h2>
        <p className="text-slate-600">Get intelligent market analysis and trading recommendations</p>
      </div>

      <div className="bg-white rounded-xl border border-slate-100 shadow-sm flex flex-col" style={{ height: 'calc(100vh - 250px)' }}>
        {/* Messages */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4">
          {messages.map((message, index) => (
            <div
              key={index}
              data-testid={`chat-message-${index}`}
              className={`flex ${
                message.role === 'user' ? 'justify-end' : 'justify-start'
              }`}
            >
              <div
                className={`max-w-[80%] rounded-lg p-4 ${
                  message.role === 'user'
                    ? 'bg-slate-900 text-white'
                    : 'bg-slate-100 text-slate-900'
                }`}
              >
                {message.role === 'assistant' && (
                  <div className="flex items-center gap-2 mb-2">
                    <BrainCircuit className="w-4 h-4 text-slate-600" />
                    <span className="text-xs font-medium text-slate-600">AI Assistant</span>
                  </div>
                )}
                <p className="text-sm leading-relaxed">{message.content}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Input */}
        <div className="border-t border-slate-200 p-4">
          <form onSubmit={handleSend} className="flex gap-2">
            <Input
              data-testid="ai-chat-input"
              type="text"
              placeholder="Ask about market insights, trading strategies..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="flex-1"
            />
            <Button data-testid="ai-chat-send-button" type="submit" size="icon">
              <Send className="w-4 h-4" />
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AIInsightsSection;